import React, { Component } from "react";
import {Link} from "react-router-dom";
import DatePicker from 'react-date-picker';
import Select from "react-select";

import './DayPlanDetails.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';

class DayPlanDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purposes : [],
      purpose : {},
      complaint : '',
      activity : '',
      outstanding : 0,
      exe_schedule : {}
    }
    this.formChange = this.formChange.bind(this);
  }

  componentDidMount(){   
    const url = `${process.env.REACT_APP_SSS}/api/getScheduleRouteDetails`;
    this.context.loading(1);
    var obj_this = this;
    var location_coordinates =  obj_this.context.location;

    if(typeof geo !== 'undefined'){
      geo.getLocation(function(location){
        if(location && location.latitude) {
            location_coordinates =  location;
            obj_this.context.setLocation(location);
        }
      });
    }

    if(typeof geo !== 'undefined'){
      if (location_coordinates.latitude == null || location_coordinates == "undefined"){
        alert("Unable to fetch Location");
        obj_this.props.history.replace("/dayplan");
        return;
      }
    }
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        exe_route_detail_id : this.props.match.params.sched_id,
        edit_schedule_id : this.props.match.params.edit_sched_id,
        latitude : location_coordinates?.latitude,
        longitude : location_coordinates?.longitude,
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          purposes : return_data.purposes,
          outstanding : return_data.outstanding,
          sales : return_data.sales,
          exe_schedule : return_data.exe_schedule,
          purpose : return_data.purpose,
          complaint : return_data.exe_schedule.complaint??'',
          activity : return_data.exe_schedule.activity??'',
          address : return_data.exe_schedule.location??''
        });
        if(!return_data.purpose){
          let purpose = obj_this.props.location.state && obj_this.props.location.state.purposeOfVisit
          // console.log(purpose);
          obj_this.setState({
            purpose : purpose
          })
        }
        
        obj_this.context.loading(0);
      }else if(return_data.status ==  "already" ){
        alert("Schedule already created.");
        obj_this.context.loading(0);
        obj_this.props.history.replace("/dayplan");
       
      }
      else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });   
  }

  purposeChange(option) {
    this.setState({
      purpose: option
    });
  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  formSubmit(e){
    e.preventDefault();
    if(this.state.purpose==null){
        this.refs.focus();
        return;
    }
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/saveScheduleRouteDetails`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        schedule_id  : this.state.exe_schedule.id,
        route_id : this.props.match.params.sched_id,
        purpose : this.state.purpose.value,
        complaint : this.state.complaint,
        activity : this.state.activity,
        outstanding : this.state.outstanding,
        sales : this.state.sales,
        edit_schedule_id : this.props.match.params.edit_sched_id
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      // return;
      if(return_data.status == "success"){
        alert("Schedule details updated");
        obj_this.props.history.replace('/dayplan');
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });
  }

  render(){
    const { history, location } = this.props;
    let collectionData;
    let salesData;
    if (location.state && location.state.from == "collection") {
      collectionData = location.state?.collectionData
    }
    if (location.state && location.state.from == "salesorder") {
      salesData = location.state?.salesData
    }
  return (
    <MyContext.Consumer>
      {context => (
        <div className="dayplan_details_page_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Schedule</div>
          </div>
          <div className="customer_details">
            <div className="customer_name">{this.state.exe_schedule.customer_name}</div>
            <div className="outstanding_sales_container" style={{display:this.state.exe_schedule.customer_type=="D"?"grid":"none"}}>
              <div className="outstanding">
                <div className="amount">{this.context.currency} {this.state.outstanding}</div>
                <div className="label">Outstanding</div>
              </div>
              <div className="sales">
                <div className="amount">{this.context.currency} {this.state.sales}</div>
                <div className="label">Sales</div>
              </div>
            </div>
          </div> 
          <form className="schedule_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="schedule_details_container blocks">
              <div className="input_label">Purpose of visit</div>
              <Select 
                className="purposes" 
                ref={r => {
                  this.refs = r;
                }}
                placeholder={""}
                options= {this.state.purposes}
                value={this.state.purpose}
                onChange={e => this.purposeChange(e)}
                required
              />
              <div className="collection_sales_button">
              {this.state.purpose?.label == "COLLECTION"?
                <Link to={{ pathname: '/collections/new',
                            state: {
                              from: 'schedule',
                              schedule_id : this.state.exe_schedule.id,
                              customer_id : this.state.exe_schedule.customer_id,
                              purposeOfVisit : this.state.purpose
                            }
                          }} ><img className="company_logo"  src={window.project_path+"/dashboard/addCollection.png"} height="100px;" /></Link>:''}

              {this.state.purpose?.label == "SALES"?
                 <Link to={{ pathname: '/salesorders/new',
                              state: {
                                from: 'schedule',
                                schedule_id :  this.state.exe_schedule.id,
                                customer_id : this.state.exe_schedule.customer_id,
                                purposeOfVisit : this.state.purpose
                              }
                            }} >
                              <img className="company_logo"  src={window.project_path+"/dashboard/addSalesOrder.png"} height="100px;" />
                             </Link>
                            :''}
                {/* <Link to={{ pathname: '/collections/new',
                            state: {
                              from: 'schedule',
                              schedule_id : this.props.match.params.edit_sched_id,
                              customer_id : this.state.exe_schedule.distributor_id,
                              purposeOfVisit : this.state.purpose
                            }
                          }}>Form 3</Link> */}
              </div>
              <div>
                <span style={{display:collectionData?"block":"none"}} className="input_label"> Collection Received : {this.context.currency} {collectionData?.amount}</span>
                <span style={{display:salesData?"block":"none"}} className="input_label"> Sale : {this.context.currency} {salesData?.grand_total}</span>

              </div>
              {/* <div className="input_label">Complaint if any</div>
              <input className="complaint input custom_input"
                type="text"
                name="complaint"
                value={this.state.complaint}
                onChange={this.formChange}
                autoComplete="off"
              /> */}
              <div className="input_label">Remarks if any</div>
               <textarea className="input activity custom_input" 
                name="activity"
                value={this.state.activity}
                onChange={this.formChange}
                // required
                autoComplete="off"
              />
            </div>

            <button type="submit" 
              className="submit_button"
              style={{display:this.state.exe_schedule.status!='CLO'?"block":'none'}}
            >
              <i className="far fa-save"></i> {this.props.match.params.sched_id?"CHECK OUT":"CHECK OUT"}
            </button>
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default DayPlanDetails;
DayPlanDetails.contextType = MyContext;
